import React from "react";
import { APP_SITE } from "@/lib/links";

/**
 * Link out to Jewish Music Lab — the Alephonics method and the app live there
 * now, not on this site.
 */
export default function JmlLink({
  children,
  path = "/alephonics",
  className,
  style,
  testId,
  arrow = true,
}) {
  return (
    <a
      href={`${APP_SITE}${path}`}
      target="_blank"
      rel="noreferrer"
      className={className}
      style={style}
      data-testid={testId}
    >
      {children}
      {arrow ? (
        <span aria-hidden="true" className="ml-1.5">
          &#8599;
        </span>
      ) : null}
    </a>
  );
}
